import { useSubscriptionContext } from "./SubscriptionContext";
import { PremiumFeature } from "./types";

export function useSubscription() {
  const ctx = useSubscriptionContext();
  return {
    isPremium: ctx.isPremium,
    tier: ctx.state.tier,
    canAccess: (feature: PremiumFeature) => ctx.canAccess(feature),
    setSubscription: ctx.setSubscription,
  };
}
